import { InputType } from 'config'

import { OTHER_INCOME_FREQUENCY } from './otherIncome.constants'

export const GROSS_MONTHLY_INCOME_TYPES = [
  'Base Income',
  'Bonus',
  'Commission',
  'Contract Basis',
  'Military Base Pay',
  'Military Clothes Allowance',
  'Military Combat Pay',
  'Military Flight Pay',
  'Military Hazard Pay',
  'Military Overseas Pay',
  'Military Prop Pay',
  'Military Quarters Allowance',
  'Military Rations Allowance',
  'Military Variable Housing Allowance',
  'Other',
  'Overtime',
] as const

const formatEmployerRoleLabel = (role: 'Primary' | 'Secondary', employer: string | undefined) =>
  `${role} Employer: ${(employer || '').trim() ? (employer as string).trim() : '[Name Not Set]'}`

export const formatPrimaryEmployerLabel = (employer: string | undefined) => formatEmployerRoleLabel('Primary', employer)

export const formatSecondaryEmployerLabel = (employer: string | undefined) =>
  formatEmployerRoleLabel('Secondary', employer)

export const getGrossMonthlyIncomeInputs = (borrowerOptions: Record<string, string>): Record<string, InputType> => ({
  borrowerSeperator: {
    title: 'Borrower',
    inputType: 'select',
    options: borrowerOptions,
    hasDefaultOption: false,
    required: true,
    disabled: true,
  },
  employer: {
    title: 'Employer',
    inputType: 'text',
    readOnly: true,
    required: false,
  },
  incomeType: {
    title: 'Income Type',
    inputType: 'select',
    options: [...GROSS_MONTHLY_INCOME_TYPES],
    hasDefaultOption: true,
    required: true,
  },
  description: {
    title: 'Description',
    inputType: 'text',
  },
  amount: {
    title: 'Amount',
    inputType: 'text',
    type: 'thousandSep',
    prefix: '$',
  },
  selfEmployment: {
    title: 'Self Employment Income',
    inputType: 'checkbox',
  },
  frequency: {
    title: 'Frequency',
    inputType: 'select',
    options: [...OTHER_INCOME_FREQUENCY],
    hasDefaultOption: true,
  },
  atrNotes: {
    title: 'ATR Notes',
    inputType: 'textarea',
    maxLength: 2000,
    rows: 4,
    span: 'full',
  },
  otherNotes: {
    title: 'Other Notes',
    inputType: 'textarea',
    maxLength: 2000,
    rows: 4,
    span: 'full',
  },
})

export const grossMonthlyIncomeColumnKeys = ['description', 'amount'] as const

export const grossMonthlyIncomeColumnHeaders: Record<string, string> = {
  description: 'Description',
  amount: 'Amount',
}

export const grossMonthlyIncomeHistoryFieldKeys = [
  'employer',
  'incomeType',
  'description',
  'amount',
  'selfEmployment',
  'frequency',
  'atrNotes',
  'otherNotes',
] as const
